import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const ObesityPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Obesity</h1>
        <section className="mb-8">
          <p>Obesity is a complex health condition characterized by excessive body fat accumulation. Our natural therapies focus on sustainable weight management through metabolic regulation, improved digestion, and lifestyle modifications, helping you achieve and maintain a healthy weight without harsh side effects.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Poor dietary habits</li>
            <li>Sedentary lifestyle</li>
            <li>Metabolic disorders</li>
            <li>Hormonal imbalances</li>
            <li>Genetic factors</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Excessive body weight</li>
            <li>Difficulty in physical activities</li>
            <li>Joint pain</li>
            <li>Shortness of breath</li>
            <li>Fatigue</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use metabolism-boosting herbs, digestive regulators, and lifestyle modifications to naturally manage weight. Our approach focuses on improving metabolic function, enhancing digestion, and promoting healthy eating habits through personalized treatment plans.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Natural weight management</li>
            <li>Improved metabolism</li>
            <li>No harsh side effects</li>
            <li>Sustainable results</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Regular exercise</li>
            <li>Balanced diet</li>
            <li>Proper sleep schedule</li>
            <li>Stress management</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: How long does it take to see results?</strong>
            <p>A: Results vary by individual, but many patients notice changes within 2-3 months of consistent treatment.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this treatment safe for long-term use?</strong>
            <p>A: Yes, our natural remedies are gentle and suitable for long-term weight management.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: Will I need to follow a strict diet?</strong>
            <p>A: We focus on sustainable lifestyle changes rather than strict diets, making it easier to maintain results.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Start your journey to a healthier weight—book your natural treatment consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default ObesityPage; 